import * as Types from '../../generated/basetypes.graphql';

import { gql } from 'graphql-tag';
import { VendorVariantModelFragmentFragmentDoc } from '../fragments/vendorVariantModel.gen';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type AddProductToUserSavedMutationVariables = Types.Exact<{
  vendorVariantId: Types.Scalars['ID'];
  quantity: Types.Scalars['Int'];
  boardId?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type AddProductToUserSavedMutation = { __typename?: 'Mutation', addProductToUserSaved?: { __typename?: 'UserSavedVendorVariant', id: string, quantity: number, vendorVariant?: { __typename?: 'VendorVariantModel', availability?: string | null, dimensions?: string | null, discountedPrice?: number | null, id: string, isReturnable: boolean, sku?: string | null, title: string, material?: string | null, color?: string | null, etaText?: string | null, image?: { __typename?: 'VendorVariantMediaModel', id: string, uri: string } | null, retailPrice?: { __typename?: 'PriceModel', id: string, price?: number | null } | null, shippingType?: { __typename?: 'ShippingTypeModel', id: string, title: string } | null, taxonomy?: { __typename?: 'TaxonomyModel', id: string, title: string } | null, vendor: { __typename?: 'VendorModel', id: string, name?: string | null } } | null } | null };


export const AddProductToUserSavedDocument = gql`
    mutation AddProductToUserSaved($vendorVariantId: ID!, $quantity: Int!, $boardId: String) {
  addProductToUserSaved(
    vendorVariantId: $vendorVariantId
    quantity: $quantity
    boardId: $boardId
  ) {
    id
    quantity
    vendorVariant {
      ...VendorVariantModelFragment
    }
  }
}
    ${VendorVariantModelFragmentFragmentDoc}`;
export type AddProductToUserSavedMutationFn = Apollo.MutationFunction<AddProductToUserSavedMutation, AddProductToUserSavedMutationVariables>;

/**
 * __useAddProductToUserSavedMutation__
 *
 * To run a mutation, you first call `useAddProductToUserSavedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductToUserSavedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductToUserSavedMutation, { data, loading, error }] = useAddProductToUserSavedMutation({
 *   variables: {
 *      vendorVariantId: // value for 'vendorVariantId'
 *      quantity: // value for 'quantity'
 *      boardId: // value for 'boardId'
 *   },
 * });
 */
export function useAddProductToUserSavedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddProductToUserSavedMutation, AddProductToUserSavedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddProductToUserSavedMutation, AddProductToUserSavedMutationVariables>(AddProductToUserSavedDocument, options);
      }
export type AddProductToUserSavedMutationHookResult = ReturnType<typeof useAddProductToUserSavedMutation>;
export type AddProductToUserSavedMutationResult = Apollo.MutationResult<AddProductToUserSavedMutation>;
export type AddProductToUserSavedMutationOptions = Apollo.BaseMutationOptions<AddProductToUserSavedMutation, AddProductToUserSavedMutationVariables>;
export const namedOperations = {
  Mutation: {
    AddProductToUserSaved: 'AddProductToUserSaved'
  }
}